<template>
  <div>
    <b-select
      size="is-medium"
      v-model="ediAccount"
      :placeholder="placeholder"
      :loading="loading"
      :disabled="loading"
      @input="announce"
      expanded>
      <option
        v-for="account in ediAccounts"
        :value="account"
        :key="account.id"
      >{{ account.qualifier }} / {{ account.identifier }}</option>
    </b-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {

  },
  data () {
    return {
      loading: false,
      ediAccount: null,
      ediAccounts: []
    }
  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/edi-accounts/'
    },
    placeholder () {
      return 'Select Account'
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$http.get(this.endpoint).then(response => {
        this.ediAccounts = response.data.results
        if (response.data.results.length === 1) {
          this.ediAccount = response.data.results[0]
          this.$emit('selected', this.ediAccount)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    announce () {
      this.$emit('selected', this.ediAccount)
    }
  },
  mounted () {
    if (this.value !== null) {
      this.ediAccount = this.value
    }
    this.load()
  },
  props: ['value']
}
</script>
